import { __assign, __rest } from "tslib";
// DS3.1.1
import React from 'react';
import InputErrorMessage from '../../InputErrorMessage';
import InputField from '../../InputField';
import InputHint from '../../InputHint';
import InputLabelSubText from '../../InputLabelSubText';
import InputLabelText from '../../InputLabelText';
import InputSuccessMessage from '../../InputSuccessMessage';
import FormElement from '../../layouts/FormElement';
import LimitedTextInputField from '../../LimitedTextInputField';
/**
 * A single line input field with a label and some details.
 */
var TextInput = React.forwardRef(function (_a, ref) {
    var label = _a.label, subLabel = _a.subLabel, isRequired = _a.isRequired, maxLength = _a.maxLength, details = _a.details, validationResult = _a.validationResult, rest = __rest(_a, ["label", "subLabel", "isRequired", "maxLength", "details", "validationResult"]);
    var wrappedDetails = null;
    switch (validationResult) {
        case 'success':
            wrappedDetails = React.createElement(InputSuccessMessage, null, details);
            break;
        case 'error':
            wrappedDetails = React.createElement(InputErrorMessage, null, details);
            break;
        default:
            wrappedDetails = React.createElement(InputHint, null, details);
    }
    return (React.createElement(FormElement, { label: label && (React.createElement(React.Fragment, null,
            React.createElement(InputLabelText, { isRequired: isRequired }, label),
            subLabel && React.createElement(InputLabelSubText, null, subLabel))), details: wrappedDetails }, maxLength === undefined ? (React.createElement(InputField, __assign({ isRequired: isRequired, validationResult: validationResult, ref: ref }, rest))) : (React.createElement(LimitedTextInputField, __assign({ maxLength: maxLength, isRequired: isRequired, validationResult: validationResult }, rest)))));
});
TextInput.displayName = 'TextInput';
export default TextInput;
//# sourceMappingURL=TextInput.js.map